import React, { useState } from "react";
import Section from "Section";
import ruhacks_logo from "./images/ruhacks_logo.png";
import mlh_banner from "./images/mlh.svg";
// import pinnacle_banner from "./images/pinnacle.png";
import { Fragment } from "react/cjs/react.production.min";

export default function Header() {
  const [open, setopen] = useState(false);
  return (
    <Fragment>
      <MobileSidebar open={open} toggle={() => setopen(!open)} />
      <Section bcolor="#202934" className="header-fixed">
        <div className="headerdesktop">
          <div className="headermobile-ham" onClick={() => setopen(true)}>
            <div />
            <div />
            <div />
          </div>
          <img
            className="headerdesktop-ruhackslogo"
            src={ruhacks_logo}
            alt=""
          />

          <div className="headerdesktop-links">
            {/* <a href="/">Application Portal</a> */}
            <a href="https://ruhacks.com/sponsorship/">Sponsor Us</a>
            {/* <a href="/">Host a Workshop</a> */}
          </div>
          <a href="https://mlh.io/seasons/2022/events">
            <img className="headerdesktop-banner mlh" src={mlh_banner} alt="" />
          </a>
          {/* <img
            className="headerdesktop-banner pinnacle"
            src={pinnacle_banner}
            alt=""
          />  */}
        </div>
      </Section>
    </Fragment>
  );
}
export const MobileSidebar = ({ toggle, open }) => {
  // const MobileSection = ({ items }) => (
  //   <div className="headermobile-section">
  //     {items.map(({ text, link }) => (
  //       <a className="headermobile-section__item" href={link}>
  //         {text}
  //       </a>
  //     ))}
  //   </div>
  // );
  // const SECTION_ONE = [{ text: "Application Portal", link: "#" }];
  // const SECTION_TWO = [
  //   { text: "Become a Mentor", link: "#" },
  //   { text: "Sponsor Us", link: "#" },
  //   { text: "Newsletter Signup", link: "#" },
  // ];
  return (
    <div className={`headermobile-con ${open ? "open" : ""}`}>
      <div onClick={toggle} className="headermobile-close">
        <div />
        <div />
      </div>
      <div className="headermobile-banner">
        {/* <img src={mlh_banner} alt="" /> */}
        {/* <img src={pinnacle_banner} alt="" /> */}
      </div>

      <div className="headermobile-body">
        {/* <MobileSection items={SECTION_ONE} />
        <div className="headermobile-bar"></div>
        <MobileSection items={SECTION_TWO} />
        <div className="headermobile-bar"></div>
        <div
          className="headermobile-section__item"
          style={{ marginBottom: "auto" }}
        >
          <div className="headermobile-section__item strong">
            Stay upto date!
          </div>
          <div className="headermobile-section__item">Newsletter Signup</div>
        </div> */}
      </div>

      <div className="headermobile-footer">
        <div className="headermobile-footer__socials">
          <a href="https://twitter.com/ryersonuhacks">
            <i className="fab fa-twitter"></i>
          </a>
          <a href="https://www.instagram.com/ruhacks/">
            <i className="fab fa-instagram"></i>
          </a>
          <a href="https://www.facebook.com/ryersonuhacks">
            <i className="fab fa-facebook-f"></i>
          </a>
        </div>
        <a
          className="headermobile-footer__email"
          href="mailto:communications@ruhacks.com"
        >
          communications@ruhacks.com
        </a>
      </div>
    </div>
  );
};
